import Dashboard from "./pages/dashboard/store";
import NgosData from "./pages/ngos-data/store";
import Notifications from "./pages/notifications/store";
import Settings from "./pages/settings/store";
import Communication from "./pages/ngos-communication/store";
import CreationRequests from "./pages/creation-requests/store";
import NgosSearch from "./pages/ngos/store";

export default {
  namespaced: true,
  modules: {
    Dashboard,
    NgosData,
    Notifications,
    Settings,
    Communication,
    CreationRequests,
    NgosSearch,
  },
};
